import React from 'react';

import { Box } from '@opendoor/bricks-next';
import type { ILpComponentMulticardFields } from 'declarations/contentful';

import MulticardCard from './MulticardCard';
import type { CardVerticalAlignment, IMulticardCardDetails } from './MulticardCard';

import styles from './MulticardList.module.css';

interface MulticardListProps {
  cards: IMulticardCardDetails[];
  componentTheme: IMulticardCardDetails['componentTheme'];
  columnNumber: number;
  isArched?: boolean;
  isAccordion?: boolean;
  minHeight?: ILpComponentMulticardFields['minHeight'];
  cardVerticalAlignment: CardVerticalAlignment;
}

const MulticardList = ({
  cards,
  componentTheme,
  columnNumber,
  isArched,
  isAccordion,
  minHeight,
  cardVerticalAlignment,
}: MulticardListProps) => (
  <Box
    tag="ul"
    m="$0"
    p="$0"
    role="list"
    gap="$4"
    className={styles.list}
    style={{ '--column-number': columnNumber } as React.CSSProperties}
  >
    {cards?.map((card, idx) => (
      <MulticardCard
        card={card}
        id={`${idx}`}
        key={idx}
        componentTheme={componentTheme}
        isArched={isArched}
        isAccordion={isAccordion}
        minHeight={minHeight}
        cardVerticalAlignment={cardVerticalAlignment}
        columnNumber={columnNumber}
      />
    ))}
  </Box>
);

export default MulticardList;
